import rpc from './core'

const urls = {
  list: {
    url: '/parish/list',
    method: 'GET'
  },
  available: {
    url: '/parish/available',
    method: 'GET'
  },
  open: {
    url: '/parish/open',
    method: 'POST'
  },
  join: {
    url: '/parish/{parish}/join',
    method: 'POST'
  },
  leave: {
    url: '/parish/{parish}/leave',
    method: 'POST'
  },
  denominations: {
    url: '/parish/denominations',
    method: 'GET'
  },
  set_parish_block_config: {
    url: '/parish/{parish}/block',
    method: 'POST'
  },
  load_parishioners: {
    url: '/parish/{parish}/parishioners',
    method: 'GET'
  },
  load_donation_types: {
    url: '/parish/{parish}/donation_types',
    method: 'GET'
  },
  save_donation_type: {
    url: '/parish/{parish}/donation_types',
    method: 'POST'
  },
  remove_donation_type: {
    url: '/parish/{parish}/donation_types/{donation_type}/remove',
    method: 'POST'
  },
  load_donations: {
    url: '/parish/{parish}/donation_types/{donation_type}/donations',
    method: 'GET'
  },
  load_all_donations: {
    url: '/parish/{parish}/donations',
    method: 'GET'
  },
  save_donation: {
    url: '/parish/{parish}/donation_types/{donation_type}/donations',
    method: 'POST'
  },
  save_parish_info: {
    url: '/parish/{parish}/update',
    method: 'POST'
  },
  load_parish_info: {
    url: '/parish/{parish}',
    method: 'GET'
  },
  load_pending_donations: {
    url: '/parish/{parish}/pending_donations',
    method: 'GET'
  },
  remove_pending_donation: {
    url: '/parish/{parish}/pending_donations/{donation}/remove',
    method: 'POST'
  },
  prepare_donations_invoice: {
    url: '/parish/{parish}/donations/invoice',
    method: 'POST'
  },
  save_currencies_list: {
    url: '/parish/{parish}/currencies',
    method: 'POST'
  },
  load_payment_fields: {
    url: '/payments/fields/{service}/{invoice}',
    method: 'GET'
  },
  check_invoice: {
    url: '/payments/{invoice}',
    method: 'GET'
  }
}

const loadParishesList = async () => {
  return rpc({ ...urls['list'] })
}
const loadAvailableParishes = async (denomination) => {
  return rpc({ params: { denomination }, ...urls['available'] })
}
const openParish = async (parish) => {
  return rpc({ data: { parish }, ...urls['open'] })
}
const joinParish = async (parish) => {
  return rpc({ params: { parish: parish.id }, ...urls['join'] })
}
const leaveParish = async (parish) => {
  return rpc({ params: { parish: parish.id }, ...urls['leave'] })
}
const loadDenominations = async () => {
  return rpc({ ...urls['denominations'] })
}
const setParishBlockConfig = async (parish, block, title, image) => {
  return rpc({ params: { parish: parish.id }, data: { block, title, image }, ...urls['set_parish_block_config'] })
}
const loadParishionersList = async (parish) => {
  return rpc({ params: { parish: parish.id }, ...urls['load_parishioners'] })
}
const saveParishInfo = async (parish) => {
  return rpc({ params: { parish: parish.id }, data: { title: parish.title, slogan: parish.slogan, description: parish.description }, ...urls['save_parish_info'] })
}
const loadParishInfo = async (parish) => {
  return rpc({ params: { parish: parish.id }, ...urls['load_parish_info'] })
}
const loadDonationTypes = async (parish) => {
  return rpc({ params: { parish: parish.id }, ...urls['load_donation_types'] })
}
const saveDonationType = async (parish, donationType) => {
  return rpc({ params: { parish: parish.id }, data: { donationType }, ...urls['save_donation_type'] })
}
const removeDonationType = async (parish, donationType) => {
  return rpc({ params: { parish: parish.id, donation_type: donationType.id }, ...urls['remove_donation_type'] })
}
const loadDonations = async (parish, donationType) => {
  return rpc({ params: { parish: parish.id, donation_type: donationType.id }, ...urls['load_donations'] })
}
const loadAllDonations = async (parish) => {
  return rpc({ params: { parish: parish.id }, ...urls['load_all_donations'] })
}
const saveDonation = async (parish, donationType, donation) => {
  return rpc({ params: { parish: parish.id, donation_type: donationType.id }, data: { donation }, ...urls['save_donation'] })
}
const loadPendingDonations = async (parish) => {
  return rpc({ params: { parish: parish.id }, ...urls['load_pending_donations'] })
}
const removePendingDonation = async (parish, donation) => {
  return rpc({ params: { parish: parish.id, donation: donation.id }, ...urls['remove_pending_donation'] })
}
const prepareDonationsInvoice = async (parish, donations) => {
  const data = {
    donations: Object.keys(donations)
  }

  return rpc({ params: { parish: parish.id }, data, ...urls['prepare_donations_invoice'] })
}
const saveCurrenciesList = async (parish, currency, currencies) => {
  return rpc({ params: { parish: parish.id }, data: { currency, currencies }, ...urls['save_currencies_list'] })
}
const loadPaymentFields = async (invoice, service) => {
  return rpc({ params: { invoice: invoice.id, service }, ...urls['load_payment_fields'] })
}
const checkInvoice = async (invoiceId) => {
  return rpc({ params: { invoice: invoiceId }, ...urls['check_invoice'] })
}

export default {
  loadParishesList,
  loadParishInfo,
  loadAvailableParishes,
  openParish,
  joinParish,
  leaveParish,
  loadDenominations,
  setParishBlockConfig,
  loadParishionersList,
  saveParishInfo,
  loadDonationTypes,
  saveDonationType,
  removeDonationType,
  loadDonations,
  saveDonation,
  loadPendingDonations,
  removePendingDonation,
  prepareDonationsInvoice,
  loadAllDonations,
  saveCurrenciesList,
  loadPaymentFields,
  checkInvoice
}
